module.exports = __webpack_public_path__ + "img/excelWhite.b45cc6e5.png";